export default "__VITE_ASSET__8GBt63Iq__"